// The following are just examples. DO NOT directly use what I already have written here in your code

export const LEVELS = {
  level1: {
    // targetFruitTrees: 10
    // buildings: {
    //   hospital: 2
    // },
    // timer: 60 * 3
  },
  level2: {
  }
}

export const CONSTANTS = {
  // tankCost = 250;
  // MOUNTS = {
  //    horse: {
  //      health: 100,
  //      speed: 5
  //   }
  // }
}